import { render, staticRenderFns } from "./SpeechAnalysisCall.vue?vue&type=template&id=4f6ed74a&scoped=true&"
import script from "./SpeechAnalysisCall.vue?vue&type=script&lang=js&"
export * from "./SpeechAnalysisCall.vue?vue&type=script&lang=js&"
import style0 from "./SpeechAnalysisCall.vue?vue&type=style&index=0&id=4f6ed74a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6ed74a",
  null
  
)

export default component.exports